export default ({ request }) => ({
    addDownloadTaskApi (data = {}) {
      return request({
        url: '/digitalCenter/sysDownload/add',
        method: 'post',
        data
      })
    },
    querySysDownloadListApi(data) {
      return request({
        url: '/digitalCenter/sysDownload/list',
        method: 'post',
        data
      })
    },
    queryNoDownloadApi(data) {
      return request({
        url: '/digitalCenter/sysDownload/queryNoDownload',
        method: 'post',
        data
      })
    },
  })
  